export const IPAPI_URL = 'https://ipapi.co/json/';
